import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./MovieCardSlider.css";

const MovieCardSlider = ({ movies }) => {
  const [transformedMovies, setTransformedMovies] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === transformedMovies.length - 1 ? 0 : prevIndex + 1
    );
  };

  // eslint-disable-next-line no-unused-vars
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? transformedMovies.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const autoSlide = setInterval(nextSlide, 5000);
    return () => clearInterval(autoSlide);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);

  useEffect(() => {
    const transformMovies = async () => {
      const transformed = await Promise.all(
        movies.map(async (movie) => {
          const posterUrl = movie.thumb_url.startsWith("http")
            ? movie.thumb_url
            : `https://phimimg.com/${movie.thumb_url}`;
          const transformedPosterUrl = `https://img.vephim.online/?url=${posterUrl}&output=webp`;

          try {
            const response = await fetch(transformedPosterUrl, { method: "HEAD" });
            return {
              ...movie,
              poster_url: response.ok ? transformedPosterUrl : posterUrl,
            };
          } catch {
            return { ...movie, poster_url: posterUrl };
          }
        })
      );

      setTransformedMovies(transformed);
    };

    transformMovies();
  }, [movies]);

  if (transformedMovies.length === 0) {
    return <div></div>;
  }

  return (
    <div className="mcs-slider">
      {transformedMovies.length > 0 && (
        <div
          className="mcs-slider-content"
          style={{
            backgroundImage: `url(${transformedMovies[currentIndex]?.poster_url})`,
          }}
        >
          {/* <button className="mcs-prev-button" onClick={prevSlide}>
            &lt;
          </button> */}
          <div className="mcs-movie-info">
            <div className="mcs-movie-title">{transformedMovies[currentIndex]?.name}</div>
            <p className="mcs-movie-details">
              {transformedMovies[currentIndex]?.year} • {" "}
              {transformedMovies[currentIndex]?.time} • {" "}
              {transformedMovies[currentIndex]?.episode_current}
            </p>
            <Link to={`/phim/${transformedMovies[currentIndex]?.slug}`}>
              <button className="mcs-watch-now">Xem ngay</button>
            </Link>
          </div>
          {/* <button className="mcs-next-button" onClick={nextSlide}>
            &gt;
          </button> */}
        </div>
      )}
    </div>
  );
};

export default MovieCardSlider;
